import { PASSWORD_MIN_CHARS } from '@rp/contracts'

export const PASSWORD_COPY = {
  forcedTitle: '請先更改密碼',
  forcedBody: '管理員替你設定了一個臨時密碼。請先改成只有你自己知道的密碼，才可以開始使用。',
  settingsTitle: '更改密碼',
  settingsHint: '要先輸入目前的密碼，確認是你本人。',
  current: '目前的密碼',
  temporary: '臨時密碼',
  next: '新密碼',
  nextHint: `最少 ${PASSWORD_MIN_CHARS} 個字元`,
  repeat: '再輸入一次新密碼',
  tooShort: `新密碼最少要 ${PASSWORD_MIN_CHARS} 個字元`,
  mismatch: '兩次輸入的新密碼不一樣',
  sameAsCurrent: '新密碼不可以和目前的密碼一樣',
  submit: '更改密碼',
  submitting: '更改中…',
  changed: '密碼已更改。',
  notRecorded: '系統未能確認密碼已經更改，請再試一次。',
  failed: '未能更改密碼，請稍後再試。',
  signOut: '登出',
} as const
